(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jsonpath"));
	else if(typeof define === 'function' && define.amd)
		define(["jsonpath"], factory);
	else if(typeof exports === 'object')
		exports["Core"] = factory(require("jsonpath"));
	else
		root["Peace"] = root["Peace"] || {}, root["Peace"]["Core"] = factory(root["jsonpath"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__1__) {
return 